import React from 'react';
import { motion } from 'framer-motion';
import { Calendar } from 'lucide-react';
interface DiaryEntryProps {
  date: string;
  title: string;
  content: string;
  index: number;
}
export function DiaryEntry({
  date,
  title,
  content,
  index
}: DiaryEntryProps) {
  return <motion.div className="bg-off-white rounded-xl p-6 md:p-8 shadow-diary border border-warm-brown/10 relative" initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} data-id="element-30">
      {/* Decorative tape effect */}
      <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-24 h-6 bg-white/40 backdrop-blur-sm border border-warm-brown/5 rotate-[-2deg] shadow-sm" data-id="element-31" />

      <div className="flex items-center gap-2 text-warm-brown/60 mb-4 font-handwritten text-xl" data-id="element-32">
        <Calendar size={18} data-id="element-33" />
        <span data-id="element-34">{date}</span>
      </div>

      <h3 className="font-handwritten text-3xl text-forest-green mb-4 font-bold" data-id="element-35">
        {title}
      </h3>

      <div className="prose prose-stone max-w-none" data-id="element-36">
        <p className="text-gray-700 leading-relaxed font-serif text-lg whitespace-pre-line" data-id="element-37">
          {content}
        </p>
      </div>
    </motion.div>;
}